import MUITable, { TableProps } from "@material-ui/core/Table";

const Table = (props: TableProps) => <MUITable {...props} />;

export default Table;
